import { createTheme, responsiveFontSizes } from "@mui/material";

export const defaultTheme = responsiveFontSizes(
	createTheme({
		palette: {
			primary: { main: "#09203F" },
			secondary: { main: "#2A5EFF" },
			background: { default: "#EFF3FA" },
		},
		typography: {
			h1: {
				fontWeight: 700,
			},
			h2: {
				fontWeight: 600,
			},
			h3: {
				fontWeight: 500,
			},
			fontFamily: "Public sans",
		},
	}),
);

export const studentTheme = responsiveFontSizes(
	createTheme({
		palette: {
			primary: { main: "#005EDC" },
			secondary: { main: "#48845E" },
			background: { default: "#EFF3FA" },
		},
		typography: {
			h1: {
				fontWeight: 700,
			},
			h2: {
				fontWeight: 600,
			},
			h3: {
				fontWeight: 500,
			},
			fontFamily: "Public sans",
		},
	}),
);
